<template>
    <div
      class="context--item--no--editable--wrapper"
      :class="{'hovered': hover && isCopyable}"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div class="context--item--no--editable--container">
        <div v-if="icon !== null" class="icon">
          <v-tooltip left :disabled="iconTooltip === null">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">{{ icon }}</v-icon>
            </template>
            <span>{{ iconTooltip }}</span>
          </v-tooltip>
        </div>
        <span v-show="attribute != null" class="attribute">{{ attribute }}</span>
        <span class="value" >{{ value }}</span>
      </div>
      <div v-show="hover && isCopyable" class="actions--panel">
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" @click="handleCopy"> far fa-copy</v-icon>
              </template>
              <span>Copied!</span>
            </v-tooltip>
          </div>
        </div>
    </div>
</template>

<script>
import { generalHelpers } from '@/_helpers'
export default {
  name: 'ContextItemNoEditable',
  props: {
    icon: { type: String, default: null },
    iconTooltip: { type: String, default: null },
    attribute: { type: String, default: null },
    value: { type: String, default: null },
    isCopyable: { type: Boolean, default: false },
    copyValue: { type: String, default: '' }
  },
  data () {
    return {
      hover: false
    }
  },
  methods: {
    handleCopy () {
      generalHelpers.copyToClipboard(this.copyValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.context--item--no--editable--wrapper {
  position: relative;
  border-radius: 5px;
  width: 100%;
  &.hovered {
     background-color: #f2f2f2;
  }
  .context--item--no--editable--container {
    position: relative;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: nowrap;
    align-items: left;
    justify-content: flex-start;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-bottom: 1px;
    width: 39vw;
    .icon {
      i {
        color: #767676;
        font-size: 16px;
      }
      flex: 1 1 10%;
      margin-right: 15px;
      max-width: 16px;
    }
    .value {
      color: #484848;
      font-size: 13px;
      font-weight: bold;
      flex: 1 1 max-content;
      margin-right: 5px;
      padding-top: 2px;
    }
    .attribute {
      color: #767676;
      font-size: 13px;
      font-weight: bold;
      flex: 1 1 max-content;
      margin-right: 5px;
      padding-top: 2px;
    }
  }
  .actions--panel {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 9;
    background-color: #f2f2f2;
    height: calc(100% - 5px);
    display: flex;
    border-left: 1px solid #ededed;

    .icon-action {
      position: relative;
      top: 0;
      width: 20px;
      height: 20px;
      text-align: center;
      border-radius: 5px;
      i {
        color: #767676;
        font-size: 18px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
}
</style>
